"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equalScalarDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var equalScalarDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createEqualScalar: _factoriesAny.createEqualScalar
};
exports.equalScalarDependencies = equalScalarDependencies;